import React, { useRef, useState } from "react";
import auth from "../../firebase.init";
import "./Login.css";
import {
  useSendPasswordResetEmail,
  useSignInWithEmailAndPassword,
  useSignInWithGoogle,
} from "react-firebase-hooks/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { Form } from "react-bootstrap";
import GoogleSign from "./GoogleSign";

const Login = () => {
const emailRef = useRef("");
const passwordRef =useRef("");
const navigate= useNavigate();
const location =useLocation();

let from = location.state?.pathname || "/checkout";
let errorElement;
const [SignInWithEmailAndPassword,
user,loading, error] = useSignInWithEmailAndPassword(auth);

if(loading){
  return(<h3 className="fw-bold text-warning">loading...</h3>)

}
if(user){
  navigate(from, {replace:true});

}
if(error){
  errorElement =<p className="text-danger"> Error: {error?.message}</p>
}

const handleSubmit =(e)=>{
e.preventDefault();
const email =emailRef.current.value;
const password = passwordRef.current.value;

SignInWithEmailAndPassword(email,password);
}
const navigateRegister = event => {
  navigate('/register');
}


return (
  <div className='container w-50 mx-auto mt-5 pt-5'>
      <h1 className='text-primary text-center mt-2'>Please Login</h1>
      <Form onSubmit={handleSubmit}>
          <Form.Group className="my-3" controlId="formBasicEmail">
              <Form.Control ref={emailRef} type="email" placeholder="Enter email" required />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Control ref={passwordRef} type="password" placeholder="Password" required />
          </Form.Group>
          <button className="button-submit px-5 py-3" type="submit">
              Login
          </button>
      </Form>
      {errorElement}
      <p className="pt-3">New to <span className="fw-bold">Exoplanet</span>? <Link to="/register" className='text-primary pe-auto text-decoration-none' onClick={navigateRegister}>Please Register</Link> </p>
      <p>Forget Password? <button className='btn btn-link text-primary pe-auto text-decoration-none'>Reset Password</button> </p>

<GoogleSign></GoogleSign>
    
  </div>
);
};


export default Login;


